import { units } from '@m/alchemy-ui/theme';
import styled from 'styled-components';
import { Input } from '@m/alchemy-ui/Input';

export const ShortInput = styled(Input)`
  width: ${units(8)};
  input {
    min-width: ${units(8)};
    width: ${units(8)};
  }
`;
